<div class="dashboard-container">

  <div class="widget" *ngxPermissionsOnly="[permissions.ROLE_LEVEL_80]">
    <mat-card appearance="raised">
      <mat-card-header>
        <mat-card-title>Open change requests</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <app-change-request-widget></app-change-request-widget>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="widget">
    <mat-card appearance="raised">
      <mat-card-header>
        <mat-card-title>Open tasks</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <app-workflow-task-widget [daysUntilDeadline]="7"></app-workflow-task-widget>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="widget" *ngxPermissionsOnly="[permissions.ROLE_LEVEL_60]">
    <mat-card appearance="raised">
      <mat-card-header>
        <mat-card-title>Failed system tasks</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <app-failed-tasks-widget></app-failed-tasks-widget>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="widget col-span-3">
    <mat-card appearance="raised">
      <mat-card-header>
        <mat-card-title>Money bar</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <app-moneybar-widget></app-moneybar-widget>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="widget" *ngxPermissionsOnly="[permissions.ROLE_LEVEL_60]">
    <mat-card appearance="raised">
      <mat-card-header>
        <mat-card-title>Paused donations</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <app-paused-donations-widget></app-paused-donations-widget>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="widget" *ngxPermissionsOnly="[permissions.ROLE_LEVEL_60]">
    <mat-card appearance="raised">
      <mat-card-header>
        <mat-card-title>Stopped donations</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <app-stopped-donations-widget></app-stopped-donations-widget>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="widget col-span-3" *ngxPermissionsOnly="[permissions.ROLE_LEVEL_20]">
    <mat-card appearance="raised">
      <mat-card-header>
        <mat-card-title>Search surveys</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <app-survey-search-widget></app-survey-search-widget>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="widget" *ngxPermissionsOnly="[permissions.ROLE_LEVEL_40]">
    <mat-card appearance="raised">
      <mat-card-header>
        <mat-card-title>New surveys</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <app-survey-summary-widget [status]="'NEW'"></app-survey-summary-widget>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="widget" *ngxPermissionsOnly="[permissions.ROLE_LEVEL_40]">
    <mat-card appearance="raised">
      <mat-card-header>
        <mat-card-title>Surveys in progress</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <app-survey-summary-widget [status]="'INPROGRESS'"></app-survey-summary-widget>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="widget" *ngxPermissionsOnly="[permissions.ROLE_LEVEL_40]">
    <mat-card appearance="raised">
      <mat-card-header>
        <mat-card-title>Group status</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <app-group-overview-widget></app-group-overview-widget>
      </mat-card-content>
    </mat-card>
  </div>
</div>
